/**
 * View panel - camera viewpoints, thumbnails, video recorder. Has data processing.
 */
import * as JQuery from "jquery";
import { Math as CesiumMath } from "cesium";
import { captureThumbnail, removeThumbnail, resetCameraView } from "../construkted_ajax";
import CameraViewpoints from "../CameraViewpoints";
import { BasePanel } from "./BasePanel";
import type { PanelContainer } from "./BasePanel";

export class ViewPanel extends BasePanel {
    private _container: ReturnType<typeof window.jQuery> | null = null;

    getId(): string {
        return "view";
    }

    getContainer(): PanelContainer {
        if (!this._container) {
            this._container = window.jQuery("#construkted-popup-view");
        }

        return this._container;
    }

    protected onInit(): void {
        const jQuery = window.jQuery;
        const viewer = window.Construkted.cesiumViewer;
        const cameraViewpoints = new CameraViewpoints(viewer);
        const construkted = window.Construkted;

        // Check if user is logged in
        const isLoggedIn =
            window.CONSTRUKTED_AJAX?.current_user?.logged === "true" || window.currentUser?.logged === "true";

        if (!isLoggedIn) {
            const resetButton = jQuery("#reset_camera_view");

            if (resetButton.length) {
                resetButton.hide();
            }

            const captureButton = jQuery(".capture-camera-viewpoint");

            if (captureButton.length) {
                captureButton.hide();
            }
        }

        let wasViewPanelActiveBeforeClick = false;

        jQuery(document).on("mousedown touchstart", "#construkted-popup-view-btn", () => {
            wasViewPanelActiveBeforeClick = jQuery("#nav-view").hasClass("active");
        });

        jQuery(document).on("click", "#construkted-popup-view-btn", () => {
            if (wasViewPanelActiveBeforeClick) {
                wasViewPanelActiveBeforeClick = false;

                return;
            }

            wasViewPanelActiveBeforeClick = false;
            setTimeout(() => cameraViewpoints.refreshViewpointsList(), 100);
        });
        jQuery(document).on("click", ".capture-view", function (this: JQuery) {
            captureThumbnail(viewer, jQuery(this));
        });
        jQuery(document).on("click", ".capture-camera-viewpoint", () => {
            cameraViewpoints.handleQuickAddViewpoint(new Event("click"));
        });
        jQuery(document).on("click", ".remove-capture", function (this: JQuery, e: JQuery.Event) {
            e.preventDefault();
            removeThumbnail(jQuery(this));
        });
        jQuery("#reset_camera_view").click(() => {
            resetCameraView();
            viewer.camera.flyHome();
        });

        if (!construkted.isProject()) {
            jQuery("#enable-video-recorder").parent().parent().hide();
        }

        jQuery("#enable-video-recorder").change(function (this: HTMLInputElement) {
            if (!construkted.isProject() || !construkted.videoRecorderWidget) {
                return;
            }

            if (this.checked) {
                construkted.videoRecorderWidget.show();
            } else {
                construkted.videoRecorderWidget.hide();
            }
        });

        const camera = viewer.camera;
        const defaultFOV = (camera.frustum as { fov: number }).fov;
        const defaultFOVInDegrees = Math.round(CesiumMath.toDegrees(defaultFOV));
        const jqCameraFieldOfViewInputRange = jQuery("#camera-field-of-view-range-input");
        const jqCameraFieldOfViewInput = jQuery("#camera-field-of-view-input");

        jqCameraFieldOfViewInputRange.val(defaultFOVInDegrees);
        jqCameraFieldOfViewInput.val(defaultFOVInDegrees);
        jqCameraFieldOfViewInputRange.on("change", () => {
            const fovInDegree = jqCameraFieldOfViewInputRange.val();

            (camera.frustum as { fov: number }).fov = CesiumMath.toRadians(Number(fovInDegree));
            jqCameraFieldOfViewInput.val(fovInDegree);
        });
        jqCameraFieldOfViewInput.on("change", () => {
            const fovInDegree = jqCameraFieldOfViewInput.val();

            (camera.frustum as { fov: number }).fov = CesiumMath.toRadians(Number(fovInDegree));
            jqCameraFieldOfViewInputRange.val(fovInDegree);
        });
        jQuery("#reset-camera-field-of-view").click(() => {
            (camera.frustum as { fov: number }).fov = defaultFOV;
            jqCameraFieldOfViewInputRange.val(defaultFOVInDegrees);
            jqCameraFieldOfViewInput.val(defaultFOVInDegrees);
        });

        const jqThreeDViewModeRadio = jQuery("#threed-view-mode-radio");

        jqThreeDViewModeRadio.prop("checked", true);
        jqThreeDViewModeRadio.click(() => construkted.set3DViewMode());
        jQuery("#twod-view-mode-radio").click(() => construkted.set2DViewMode());
        jQuery("#twod-view-mode-north-up-radio").click(() => construkted.set2DViewNorthUpMode());
        jQuery("#wireframe-shading-radio").click(() => construkted.setWireframeShadingMode());
        jQuery("#solid-shading-radio").click(() => construkted.setSolidShadingMode());
        jQuery("#texture-shading-radio").prop("checked", true);
        jQuery("#texture-shading-radio").click(() => construkted.setTextureShadingMode());
    }
}
